import Vue from 'vue'
import store from '@/store/'
import {
  ACCESS_TOKEN,
  DEFAULT_COLOR,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR_WEAK,
  SIDEBAR_TYPE,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_CONTENT_WIDTH_TYPE,
  DEFAULT_MULTI_TAB
} from '@/store/mutation-types'
import config from '@/config/defaultSettings'

export default function Initializer () {
  console.log(`API_URL: ${process.env.VUE_APP_API_BASE_URL}`)

  // 确保所有配置都有默认值，避免 undefined
  const sidebarType = Vue.ls.get(SIDEBAR_TYPE)
  const theme = Vue.ls.get(DEFAULT_THEME)
  const layoutMode = Vue.ls.get(DEFAULT_LAYOUT_MODE)
  const fixedHeader = Vue.ls.get(DEFAULT_FIXED_HEADER)
  const fixedSiderbar = Vue.ls.get(DEFAULT_FIXED_SIDEMENU)
  const contentWidth = Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE)
  const fixedHeaderHidden = Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN)
  const colorWeak = Vue.ls.get(DEFAULT_COLOR_WEAK)
  const color = Vue.ls.get(DEFAULT_COLOR)
  const multiTab = Vue.ls.get(DEFAULT_MULTI_TAB)
  const token = Vue.ls.get(ACCESS_TOKEN)

  store.commit('SET_SIDEBAR_TYPE', sidebarType !== undefined ? sidebarType : true)
  store.commit('TOGGLE_THEME', theme !== undefined && theme !== null ? theme : (config.navTheme || 'light'))
  store.commit('TOGGLE_LAYOUT_MODE', layoutMode !== undefined && layoutMode !== null ? layoutMode : (config.layout || 'sidemenu'))
  store.commit('TOGGLE_FIXED_HEADER', fixedHeader !== undefined && fixedHeader !== null ? fixedHeader : (config.fixedHeader !== undefined ? config.fixedHeader : true))
  store.commit('TOGGLE_FIXED_SIDERBAR', fixedSiderbar !== undefined && fixedSiderbar !== null ? fixedSiderbar : (config.fixSiderbar !== undefined ? config.fixSiderbar : true))
  store.commit('TOGGLE_CONTENT_WIDTH', contentWidth !== undefined && contentWidth !== null ? contentWidth : (config.contentWidth || 'Fixed'))
  store.commit('TOGGLE_FIXED_HEADER_HIDDEN', fixedHeaderHidden !== undefined && fixedHeaderHidden !== null ? fixedHeaderHidden : (config.autoHideHeader !== undefined ? config.autoHideHeader : false))
  store.commit('TOGGLE_WEAK', colorWeak !== undefined && colorWeak !== null ? colorWeak : (config.colorWeak !== undefined ? config.colorWeak : false))
  store.commit('TOGGLE_COLOR', color !== undefined && color !== null ? color : (config.primaryColor || '#FABE00'))
  store.commit('TOGGLE_MULTI_TAB', multiTab !== undefined && multiTab !== null ? multiTab : (config.multiTab !== undefined ? config.multiTab : false))
  store.commit('SET_TOKEN', token)

  // last step
}
